<template>
  <div class="gird">
    <vxe-grid
      border
      show-overflow
      resizable
      ref="xGridReturn"
      class="vxe-table-element"
      size="mini"
      align="left"
      :auto-resize="true"
      :data="tableData"
    >
      <vxe-table-column type="checkbox" width="60"></vxe-table-column>
      <vxe-table-column type="seq" width="60" :title="$t('table.index')"></vxe-table-column>
      <vxe-table-column
        field="productName"
        :title="$t('purchaseReturn.form.goodList.productCode')"
      ></vxe-table-column>
      <vxe-table-column
        field="businessInboundNo"
        :title="$t('purchaseReturn.form.goodList.businessInboundNo')"
      ></vxe-table-column>
      <vxe-table-column
        field="returnQuantity"
        :title="$t('purchaseReturn.form.goodList.returnQuantity')"
      ></vxe-table-column>
      <vxe-table-column
        field="businessInboundBatchNo"
        :title="$t('purchaseReturn.form.goodList.businessInboundBatchNo')"
      ></vxe-table-column>
      <vxe-table-column
        field="returnAmount"
        :title="$t('purchaseReturn.form.goodList.returnAmount')"
      ></vxe-table-column>
      <vxe-table-column
        field="returnCurrencyName"
        :title="$t('purchaseReturn.form.goodList.returnCurrency')"
      ></vxe-table-column>
      <vxe-table-column
        field="actualOutboundQuantity"
        :title="$t('purchaseReturn.form.goodList.actualOutboundQuantity')"
      ></vxe-table-column>
      <vxe-table-column
        field="productUnitName"
        :title="$t('purchaseReturn.form.goodList.productUnit')"
      ></vxe-table-column>
    </vxe-grid>
  </div>
</template>
<script>
  export default {
    name: 'exchangeDetail',
    props: {
      // tableData:{
      //     type:Array,
      //     default: () => [{}]
      // },
      // isReturn:{
      //     type:Number,
      //     default:0
      // }
    },
    data() {
      return {
        tableData: [],
      };
    },
    methods: {
      setVal(val) {
        this.tableData = val;
      },
    },
  };
</script>
